import { getTravellerFormSchemaRequestKey } from 'checkout/selectors/request/travellerSchema'
import watch from 'redux-watch'
import { AppStore } from 'src/client/store'
import {
  saveCheckoutReduxCartState,
  saveCheckoutReduxFormState,
  saveCheckoutReduxPaymentState,
} from 'storage/checkout'

export function watchCheckout(store: AppStore) {
  store.subscribe(
    watch(store.getState, 'checkout')(async(newState: App.CheckoutState, oldState: App.CheckoutState) => {
      if (newState.cart !== oldState.cart && !newState.cart.isAbandonedCart) {
        const cart = {
          ...newState.cart,
          lastSaveTimestamp: Date.now(),
        }
        saveCheckoutReduxCartState(cart)
      }

      const fullState = store.getState()
      const schemaKey = getTravellerFormSchemaRequestKey(fullState)
      const oldFormSchema = oldState.schemaData[schemaKey]
      const newFormSchema = newState.schemaData[schemaKey] ?? undefined

      if (newState.isFormInitialised && (newState.form !== oldState.form || newFormSchema !== oldFormSchema)) {
        const memberId = fullState.auth.account.memberId
        saveCheckoutReduxFormState(newState.cart.cartId, newState.form, newFormSchema, memberId)
      }

      if (newState.payment !== oldState.payment) {
        if (newState.promo?.code) {
          newState.payment.promoCode = newState.promo?.code
        }
        saveCheckoutReduxPaymentState(newState.payment)
      }
    }),
  )
}
